import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    // 禁用瀏覽器的自動捲動恢復，避免與手動捲動衝突
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  }, [pathname, search]); // 加入 search，確保網址參數改變時（例如 ?id=123）也會捲動

  return null;
}

export default ScrollToTop;